import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { memo } from "react";
import { areEqual } from "react-window";
import { stopPropagationHandler } from "../../utils";
export var VirtualizedOption = /*#__PURE__*/memo(function (_ref) {
  var data = _ref.data,
    index = _ref.index,
    style = _ref.style;
  var getItemProps = data.getItemProps,
    getRenderedOption = data.getRenderedOption,
    highlightedIndex = data.highlightedIndex,
    options = data.options,
    getOptionKey = data.getOptionKey,
    isOptionSelected = data.isOptionSelected,
    metadata = data.metadata;
  var option = options[index];
  var key = getOptionKey(option);
  return getRenderedOption(option, index, highlightedIndex, getItemProps({
    item: option,
    index: index,
    style: _objectSpread(_objectSpread({}, style), {}, {
      width: "calc(100% - 16px)"
    }),
    onClick: stopPropagationHandler,
    key: key
  }), isOptionSelected, metadata);
}, areEqual);
VirtualizedOption.displayName = "VirtualizedOption";
//# sourceMappingURL=VirtualizedOption.js.map